/// <reference path="../../ng-services/chat.service.ts"/>

import { LightboxItem, LightboxService } from '../../ng-services/lightbox.service';

(function () {
    class LightboxComponent {
        static $inject = ['LightboxService'];

        items!: LightboxItem[];
        resolve: any;
        modalInstance: any;

        currentId: any;

        get current() {
            return this.items.filter((item) => item.id === this.currentId)[0];
        }

        get owner() {
            return this.current.owner;
        }

        get ownerImage() {
            return this.current?.owner?.picture_url || this?.current?.owner?.picture?.source;
        }

        get downloadUrl() {
            return this.current.download_url;
        }

        get isImage() {
            return this.lightboxService.isImage(this.current.file_mimetype);
        }

        get isVideo() {
            return this.lightboxService.isVideo(this.current.file_mimetype);
        }

        get isPdf() {
            return this.lightboxService.isPdf(this.current.file_mimetype);
        }

        get isUnsupported() {
            return !this.lightboxService.isSupported(this.current.file_mimetype);
        }

        constructor(private lightboxService: LightboxService) {}

        $onInit() {
            this.items = this.resolve.items;
            this.currentId = this.resolve.current || this.resolve.items[0].id;
        }

        close() {
            this.modalInstance.close();
        }

        cancel() {
            this.modalInstance.dismiss('cancel');
        }

        download() {
            window.open(this.downloadUrl, '_blank');
        }

        next() {
            const index = this.getCurrentIndex() + 1;
            this.currentId = this.items[index >= this.items.length ? 0 : index].id;
        }

        prev() {
            const index = this.getCurrentIndex() - 1;
            this.currentId = this.items[index < 0 ? this.items.length - 1 : index].id;
        }

        get hasManyItems() {
            return this.items.length > 1;
        }

        private getCurrentIndex(): number {
            let index = 0;
            this.items.forEach((item, i) => {
                if (item.id === this.currentId) {
                    index = i;
                }
            });
            return index;
        }

        private updateItem(id: any, update: any) {
            this.items = this.items.map((item) =>
                item.id === id
                    ? {
                          ...item,
                          ...update,
                      }
                    : item
            );
        }
    }

    angular.module('tradersyard').component('tyLightbox', {
        template: `<div class="lightbox">
    <div class="modal-header">
        <h3 class="modal-title" id="modal-title">
            <div class="lightbox__info">
                <div ng-if="$ctrl.ownerImage" class="lightbox__avatar">
                    <img ng-src="{{$ctrl.ownerImage|thumb:80:80}}" alt="avatar">
                </div>
                <div>
                    <div class="lightbox__title" ng-if="$ctrl.current.name">{{$ctrl.current.name}}</div>
                    <div class="lightbox__meta" is-uib>
                        <div ng-if="$ctrl.owner" class="lightbox__owner">{{$ctrl.owner.name}}</div>
                        <div
                                ng-if="$ctrl.current.created_at"
                                class="lightbox__created_at"
                                moment-watch="$ctrl.current.created_at"
                                uib-tooltip="{{$ctrl.current.created_at | moment:'L LT'}}"
                        ></div>
                    </div>
                </div>
            </div>

            <div class="lightbox__actions">
                <a href="#" ng-click="$ctrl.download()" uib-tooltip="Download"><i class="fa fa-download"></i></a>
                <a href="#" ng-click="$ctrl.close()" uib-tooltip="Close"><i class="fa fa-times"></i></a>
            </div>
        </h3>
    </div>
    <div class="modal-body" id="modal-body">
        <a ng-if="$ctrl.hasManyItems" class="btn btn-default lightbox__btn_prev" href="#" ng-click="$ctrl.prev()"><i
                class="fa fa-angle-left"></i></a>
        <a ng-if="$ctrl.hasManyItems" class="btn btn-default lightbox__btn_next" href="#" ng-click="$ctrl.next()"><i
                class="fa fa-angle-right"></i></a>
        <ty-lightbox-image ng-if="$ctrl.isImage" ng-repeat="item in [$ctrl.current]" item="item"/>
        <ty-lightbox-video ng-if="$ctrl.isVideo" ng-repeat="item in [$ctrl.current]" item="item"/>
        <ty-lightbox-pdf ng-if="$ctrl.isPdf" ng-repeat="item in [$ctrl.current]" item="item"/>
        <ty-lightbox-unsupported ng-if="$ctrl.isUnsupported" ng-repeat="item in [$ctrl.current]" item="item"/>
    </div>
</div>`,
        controller: LightboxComponent,
        bindings: {
            resolve: '<',
            modalInstance: '<',
            close: '&',
            dismiss: '&',
        },
    });
})();
